import { useEffect, useState } from 'react';
import {
  ParticipantFilesSummary,
  getParticipantFilesSummary,
  peekParticipantFilesSummary,
} from 'services/actions/ai_management_hiring_history';

const EMPTY: ParticipantFilesSummary = { documentos: [], contratos: [] };

const digits = (cnpj: string | null | undefined) => (cnpj ?? '').replace(/\D/g, '');

export function useParticipantFiles(biddingId: number | null, historicBiddingId: number) {
  const peek = () =>
    biddingId ? peekParticipantFilesSummary(biddingId, historicBiddingId) : undefined;
  const [summary, setSummary] = useState<ParticipantFilesSummary>(() => peek()?.data ?? EMPTY);

  useEffect(() => {
    if (!biddingId) {
      setSummary(EMPTY);
      return undefined;
    }

    const hit = peek();
    if (hit) {
      setSummary(hit.data);
      return undefined;
    }

    let active = true;
    setSummary(EMPTY);

    getParticipantFilesSummary(biddingId, historicBiddingId)
      .then(({ data }) => {
        if (active) setSummary(data);
      })
      .catch(() => {
        if (active) setSummary(EMPTY);
      });

    return () => {
      active = false;
    };
  }, [biddingId, historicBiddingId]);

  return {
    hasDocuments: (cnpj: string | null) => summary.documentos.includes(digits(cnpj)),
    hasContracts: (cnpj: string | null) => summary.contratos.includes(digits(cnpj)),
  };
}
